
export default class HttpRequests {

    protected _xhr: XMLHttpRequest | null = null;

    get xhr(): XMLHttpRequest | null {
        return this._xhr;
    }

    constructor() {
        this._xhr = new XMLHttpRequest();
    }

    /**
     * Makes an HTTP request.
     *
     * @param {string} method - The HTTP method to use.
     * @param {string} url - The URL to send the request to.
     * @param {any} data - Optional data to send with the request.
     * @return {Promise<string>} A Promise that resolves to the response text.
     */
    public makeHttpRequest(method: string, url: string, data?: any): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            if (!this._xhr) {
                reject(new Error("XHR instance not available."));
                return;
            }

            this._xhr.open(method, url, true);

            /**
             * Sets an event handler for the `readystatechange` event of the XMLHttpRequest object.
             *
             * @return {void} None
             */
            this._xhr.onreadystatechange = (): void => {
                if (this._xhr!.readyState === 4) {
                    if (this._xhr!.status === 200) {
                        resolve(this._xhr!.responseText);
                    } else {
                        reject(new Error(`Error during ${method} request. Statut : ${this._xhr!.status}`));
                    }
                }
            };


            const controller = new AbortController();
            const signal = controller.signal;
            this._xhr["signal"] = signal;

            signal.addEventListener('abort', () => {
                this._xhr!.abort();
                reject(new Error('Request cancelled'));
            });

            if (data) {
                this._xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
                this._xhr.send(JSON.stringify(data));
            } else {
                this._xhr.send();
            }
        });
    }

    /**
     * Cancels the current request.
     */
    public cancelRequest(): void {
        if (this._xhr) {
            this._xhr.abort();
        }
    }
}



// WEBPACK FOOTER //
// ./js/utils/HttpRequest.ts